exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".laya-swim-fitting .videoWrapper[data-v-19df4c7a] {\n  position: relative;\n  padding-bottom: 56.25%;\n  /* 16:9 */\n  height: 0;\n}\n.laya-swim-fitting .videoWrapper iframe[data-v-19df4c7a] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports
